export const STANDBY_STRINGS: Record<string, [string, string, string]> = {
  'standby.welcome': ['歡迎登船', 'Welcome aboard', 'ようこそ'],
  'standby.subtitle': [
    '小獅船長陪您探索旅程',
    'Explore with Captain Lion',
    'キャプテンライオンと旅へ',
  ],
  'standby.subtitle.noMascot': [
    '一起探索精彩旅程',
    'Discover your next journey',
    '新しい旅を見つけよう',
  ],
  'standby.description': [
    '搭遊艇・體驗水上活動・探索景點',
    'Cruises · Water activities · Discoveries',
    'クルーズ・水上体験・観光',
  ],
  'standby.start': ['輕觸畫面開始', 'Touch the screen to begin', '画面にタッチして開始'],
  'idle.description': [
    '為保護你的資料，即將清除本次操作並返回開始畫面。',
    'For your privacy, this session will be cleared and the start screen will open.',
    '個人情報保護のため、今回の操作内容を消去して開始画面に戻ります。',
  ],
  'idle.exit': ['結束操作', 'End session', '操作を終了'],
  'idle.paused': [
    '處理中，暫停倒數',
    'Processing — timeout paused',
    '処理中・タイムアウトを一時停止',
  ],
};
